<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h2 class="text-white">ROCS</h2>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Home</a>
                        </li>/
                        <li class="active">
                            <a href="javascript:void(0);">ROCS</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="ptb--100 ">
    <div class="container">
        <div class="row justify-content-center gx-4">
            <div class="col-md-12">
                <p>The Raisoni Office of Career Services ( ROCS) is a unique new initiative undertaken for the first
                    time among educational institutions in Central India, to TRANSFORM STUDENTS CAREER PATHWAY, like
                    never before :</p>
                <h4 class="yellow-color fw-bold my-2">Key Benefits envisaged for the students, include:</h4>
                <ul class="list-before">
                    <li><b>INTEGRATED</b> Training, Placements, III Cell &amp; Alumni activities in each campus</li>
                    <li><b>PERSONALIZED</b> service to students</li>
                    <li><b>Career Pathway for each student</b> WILL BE discussed</li>
                    <li>Student <b>MENTOR</b> is assigned in all colleges</li>
                    <li>DEVELOPMENT of <b>INDIVIDUAL Student Development plan </b></li>
                    <li><b>ROCS – TRANSFORMING STUDENTS CAREER PATHWAY</b></li>
                </ul>
                <p>Preparing our young professionals for the next steps may involve self-discovery, exploration, and
                    skill development, honing their interviewing skills, and developing a timeline for how they will
                    achieve their goals. The 4 keys areas of ROCS are:</p>
                <ul>
                    <li><strong>Self-Discovery :</strong> Learning about who you are and how you want to make an impact
                        is a great place to begin. Careers that combine your skills, interests, values, and personality
                        are usually a great fit.</li>
                    <li><strong>Exploration :</strong> Exploring your personal, academic, and career interests enables
                        you to begin to develop career goals. Reflecting on experiences in your classes, internships,
                        student groups, and community will generate many interesting options to consider and learn more
                        about.</li>
                    <li><strong>Preparation :</strong> Preparing for your next steps may involve developing relevant
                        skills. But it will also involve putting together a strong resume, learning how to write a cover
                        letter, developing graduate school or fellowship applications, understanding the importance of
                        networking, honing your interviewing skills, and developing a timeline for how you’ll achieve
                        your goals.</li>
                    <li><strong>Action :</strong> Once you have some ideas about next steps, you’re ready to move
                        forward!</li>
                </ul>
                <h4 class="yellow-color fw-bold my-2">Key Deliverables - NEW, BETTER & DIFFERENT</h4>
                <table class="table">
                    <tr>
                        <td>
                            <p><strong> NEW</strong></p>
                            <ul class="list-before">
                                <li>Industry Need Analysis</li>
                                <li>Competencies Employers Looking For</li>
                            </ul>
                        </td>
                        <td>
                            <p><strong> BETTER</strong></p>
                            <ul class="list-before">
                                <li>CV Refinement, Mentoring, Aptitude</li>
                                <li>SAR Stories</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><strong> DIFFERENT</strong></p>
                            <ul class="list-before">
                                <li>Individualized Student Development Plan</li>
                                <li>Integrated Approach - SEPA Concept</li>
                            </ul>
                        </td>
                    </tr>
                </table>
                <p>The key differentiator envisaged in ROCS is an INDIVIDUALIZED STUDENT DEVELOPMENT PLAN, which
                    recognizes the fact that every student is special and his or her development needs are different
                    from many others. ROCS works to educate, connect, and advise students about opportunities for summer
                    and post-graduation in order to foster their intellectual, social, and personal transformations.</p>
            </div>
        </div>
    </div>
</section>
